import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";

function FormConsentInputPreview({ ...props }) {
  return <BasePreview {...props}>
    <input type="checkbox" />
  </BasePreview>
}

export default define('form-consent-input', FormConsentInputPreview, Fragment)
  .shared(prop.share('FormConsentInput', 'form-consent-input'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

